import { useMemo } from 'react';

const SPACE_REGEX = /\s/g;

const useComponentId = (id: string) => useMemo(() => id.replace(SPACE_REGEX, '-'), [id]);

export default useComponentId;
